import pluralize from 'pluralize';

export const filter = (value, number) => {
    return pluralize(value, number);
};
export default filter;



// WEBPACK FOOTER //
// ./src/app/filters/pluralize.js